import React from "react";

export default function MarketingFooter() {
    return (
        <footer className="border-t border-border-subtle bg-bg-page">
            <div className="mx-auto md:px-16 px-8 py-8">
                {/* Top row */}
                <div className="flex flex-col md:flex-row items-center justify-between gap-4 sm:flex-row border-b-2 pb-6">
                    {/* Brand */}
                    <span className="text-xl font-medium text-primary">Eikos Health</span>

                    {/* Links */}
                    <nav className="flex flex-col md:flex-row items-center justify-between gap-2 md:gap-6 text-sm text-text-muted">
                        <a href="/terms" className="hover:text-text-primary transition-colors">
                            Terms of Service
                        </a>
                        <a href="/privacy" className="hover:text-text-primary transition-colors">
                            Privacy Policy
                        </a>
                        <a href="/refund-policy" className="hover:text-text-primary transition-colors">
                            Refund Policy
                        </a>
                        <a href="/support" className="hover:text-text-primary transition-colors">
                            Contact Support
                        </a>
                    </nav>
                </div>

                {/* Disclaimer */}
                <p className="mt-6 text-center text-sm text-text-muted">
                    Eikos Health services are available only to verified medical professionals and licensed healthcare
                    facilities.
                </p>
            </div>
        </footer>
    );
}
